.main-row.build-content
    .container
        .row
            .col-xs-12
                h1.editable-title(contenteditable=page.isEditable, spellcheck='false')= content.name

                br
